import { X } from 'lucide-react';
import { SyntheticEvent } from 'react';

import { clsx } from 'clsx';

import { useComparison } from '@screens/Comparison';
import { ICON_SECONDARY } from '@shared/constants/colors';
import { Container } from '@shared/ui/Container';
import { HStack } from '@shared/ui/Stack';

import cls from './CategoryTabs.module.scss';

export const CategoryTabs = () => {
  const { products, activeCategory, changeActiveCategory, clearCategory } = useComparison();

  const removeCategory = (e: SyntheticEvent, category: string) => {
    e.stopPropagation();
    clearCategory(category);
  };

  if (!Object.keys(products).length) {
    return;
  }

  return (
    <div className={cls.wrap}>
      <Container>
        <HStack className={cls.flex}>
          {Object.keys(products).map((category) => (
            <button
              key={category}
              aria-label={`Показать сравнение товаров по категории ${category}`}
              className={clsx(cls.button, { [cls.active]: activeCategory === category })}
              onClick={() => changeActiveCategory(category)}
            >
              <span>
                {category} {Object.values(products[category]).length}
              </span>

              <X
                onClick={(e) => removeCategory(e, category)}
                size={20}
                color={ICON_SECONDARY}
              />
            </button>
          ))}
        </HStack>
      </Container>
    </div>
  );
};
